import { render } from "./NavigationItem.vue?vue&type=template&id=6963aecb&scoped=true"
import script from "./NavigationItem.vue?vue&type=script&lang=js"
export * from "./NavigationItem.vue?vue&type=script&lang=js"

import "./NavigationItem.vue?vue&type=style&index=0&id=6963aecb&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6963aecb"]])

export default __exports__